import React from 'react'
import { Box, Flex, Image, Text, useDisclosure } from '@chakra-ui/react'
import { useGlobalContext } from 'providers/GlobalProvider'
import { useAuthContext } from 'providers/AuthProvider'
import IBModalAction from 'components/common/IBModalAction/IBModalAction'
import useAxiosErrorHandler from 'hooks/useAxiosErrorHandler'
import { capitalizeByWord } from 'utils/functions/formatString'
import backNavBar from '../../assets/images/navbar.png'
import IBLogo from '../../assets/images/logo.svg'
import UserMenu from './userMenu/UserMenu'
import ChangeCompany from './changeCompany/ChangeCompany'

const Header = () => {
  const { userProfile, headerInfo: { title, subtitle }, companyQuantity, companyName } = useGlobalContext()
  const { logout, signinRedirect } = useAuthContext()
  useAxiosErrorHandler({
    '401': async () => {
      if (!(process.env.DISABLE_ERROR_HANDLER ?? false)) {
        console.error('ErrorHandler-redirect')
        signinRedirect()
      }
    },
  })
  const isDisablechangeCompany = companyQuantity <= 0
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenChangeCompany, onOpen: onOpenChangeCompany, onClose: onCloseChangeCompany } = useDisclosure()
  const modal = {
    title: 'Estás por cerrar sesión',
    bodyModal: '¿Estás seguro que deseás cerrar sesión?',
    footerModal: {
      cancel: 'Cancelar',
      closeSessionText: 'Sí, cerrar sesión',
      closeSession: async () => {
        logout()
      }
    }
  }

  return (
    <Flex
      h='96px'
      bgImage={backNavBar}
      bgRepeat='no-repeat'
      bgSize='cover'
      position='relative'
      zIndex={20}
    >
      <Box
        pb={1} w='76px'
        bg='tertiary.110'
        borderRadius='0px 20px 0px 0px'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <a href='/'>
          <Image
            alt='Interbanking Logo'
            src={IBLogo}
            w={27}
          />
        </a>
      </Box>
      <Box
        flex='1'
      >
        <Box
          display='flex'
          alignItems='center'
          h='96px'
          px={4}
        >
          <Flex
            h={16}
            w='100%'
            alignItems='center'
            pr='40px'
            pl='35px'
            justifyContent='space-between'
          >
            <Flex flexDir='column'>
              {(title && userProfile?.profile?.name) &&
                <Text fontSize='24px' lineHeight='32px'>
                  ¡{title}, {capitalizeByWord(userProfile?.profile?.name.toLowerCase())}!
                </Text>
              } {
                subtitle && title && userProfile?.profile?.name &&
                <Text fontSize='16px' lineHeight='22px'>
                  {subtitle}
                </Text>
              }{
                subtitle && !title &&
                <Text fontSize='24px'>
                  {subtitle}
                </Text>
              }
            </Flex>
            <UserMenu
              userName={userProfile?.profile?.name}
              companyName={companyName}
              isDisablechangeCompany={isDisablechangeCompany}
              logoutAction={onOpen}
              changeCompany={onOpenChangeCompany}
            />
          </Flex>
        </Box>
      </Box>
      <IBModalAction
        isOpen={isOpen}
        onClose={onClose}
        buttonActionText={modal?.footerModal.closeSessionText}
        buttonAction={modal?.footerModal.closeSession}
        buttonCancel={modal?.footerModal.cancel}
        title={modal?.title}
        textBody={modal?.bodyModal}
      />
      {isOpenChangeCompany && (
        <ChangeCompany
        isOpen={isOpenChangeCompany}
        onClose={onCloseChangeCompany}
      />
      )}
    </Flex>
  )
}

export default Header

